<template>
  <div>
    <h1 style="margin: 0 0 4px">Checkride Schedule</h1>
    <div class="row button-margins justify-content-between ml-0 mr-0">
      <hilo-button label="Add +" @click="navigateToAddCheckride" />
      <hilo-button
        :label="
          showEmailTemplates ? 'Hide Email Templates' : 'Show Email Templates'
        "
        @click="toggleShowEmailTemplates"
      />
    </div>

    <div class="tab-container">
      <div
        class="tab"
        :class="{ selected: selectedTab === 'Scheduled' }"
        @click="selectTab('Scheduled')"
      >
        Scheduled
      </div>
      <div
        class="tab"
        :class="{ selected: selectedTab === 'Available' }"
        @click="selectTab('Available')"
      >
        Available
      </div>
      <div
        class="tab"
        :class="{ selected: selectedTab === 'Pending' }"
        @click="selectTab('Pending')"
      >
        Pending
      </div>
      <div
        class="tab"
        :class="{ selected: selectedTab === 'Completed' }"
        @click="selectTab('Completed')"
      >
        Completed
      </div>
      <div class="search-wrapper">
        <input
          class="search-input"
          v-model="search"
          placeholder="Search"
          @input="filterCheckrides"
        />
      </div>
    </div>
    <div class="table-header">
      <div class="toggle-container">
        <span class="toggle-label">Show Personal Details</span>
        <label class="switch">
          <input type="checkbox" v-model="showPersonalDetails" />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
    <hilo-table :columns="columns" :data="filteredCheckrides" />
    <email-templates
      v-if="showEmailTemplates"
      :templates="emailTemplates"
      @save-templates="saveEmailTemplateChanges"
    />
    <hilo-modal
      :isVisible="showDpeEmailModal"
      title="Confirm DPE Email"
      :data="selectedCheckride"
      :footerButtons="dpeEmailFooterButtons"
      @close="closeModal('showDpeEmailModal')"
    >
      <div>
        <div>
          Please confirm that you would like to send the following dpe email.
        </div>
        <br />
        <div>Subject: {{ selectedCheckride.subject }}</div>
        <br />
        <div v-html="selectedCheckride.body"></div>
      </div>
    </hilo-modal>
    <hilo-modal
      :isVisible="showStudentEmailModal"
      title="Confirm Student Email"
      :data="selectedCheckride"
      :footerButtons="studentEmailFooterButtons"
      @close="closeModal('showStudentEmailModal')"
    >
      <div>
        <div>
          Please confirm that you would like to send the following student
          email.
        </div>
        <br /><br />
        <div>Subject: {{ selectedCheckride.subject }}</div>
        <br />
        <div v-html="selectedCheckride.body"></div>
      </div>
    </hilo-modal>
    <!--    V2-->
    <!--    <div v-if="isTaskModalOpen" class="modal">-->
    <!--      <div class="modal-content">-->
    <!--        <span class="close" @click="closeTaskModal">&times;</span>-->
    <!--        <h1>Checkride Tasks</h1>-->
    <!--        <table class="tasks-table">-->
    <!--          <thead>-->
    <!--            <tr>-->
    <!--              <th>Task</th>-->
    <!--              <th>Assigned to</th>-->
    <!--            </tr>-->
    <!--          </thead>-->
    <!--          <tbody>-->
    <!--            <tr v-for="task in tasks" :key="task.id">-->
    <!--              <td>-->
    <!--                <select v-model="task.name" class="task-select">-->
    <!--                  <option-->
    <!--                    v-for="taskOption in taskOptions"-->
    <!--                    :key="taskOption"-->
    <!--                    :value="taskOption"-->
    <!--                  >-->
    <!--                    {{ taskOption }}-->
    <!--                  </option>-->
    <!--                </select>-->
    <!--              </td>-->
    <!--              <td>-->
    <!--                <select v-model="task.assignedTo" class="assigned-to-select">-->
    <!--                  <option-->
    <!--                    v-for="person in assignedToOptions"-->
    <!--                    :key="person"-->
    <!--                    :value="person"-->
    <!--                  >-->
    <!--                    {{ person }}-->
    <!--                  </option>-->
    <!--                </select>-->
    <!--              </td>-->
    <!--              <td class="delete-column">-->
    <!--                <button @click="deleteTask(task.id)" class="delete-button">-->
    <!--                  <i class="fas fa-trash"></i>-->
    <!--                </button>-->
    <!--              </td>-->
    <!--            </tr>-->
    <!--          </tbody>-->
    <!--        </table>-->
    <!--        <div class="button-row">-->
    <!--          <hilo-button label="Add Task" @click="addTask" />-->
    <!--          <hilo-button label="Done" @click="closeTaskModal" />-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <NotesModal
      v-if="showNotesModal && selectedCheckride && selectedCheckride.id"
      :isVisible="showNotesModal"
      :targetUserId="selectedCheckride?.activeStudent?.user?.id"
      :targetName="`${selectedCheckride?.firstName} ${selectedCheckride?.lastName}`"
      filterTargetUserByNoteType
      noteTypeName="Checkride"
      @close="closeModal('showNotesModal')"
    />
  </div>
</template>

<script>
import HiloTable from "src/components/HiloComponents/HiloTable.vue";
import HiloButton from "src/components/HiloComponents/HiloButton.vue";
import HiloModal from "@/components/HiloComponents/HiloModal.vue";
import NotesModal from "@/components/HiloComponents/NotesModalOld.vue";
import EmailTemplates from "@/components/HiloComponents/EmailTemplates.vue";
import EmailAPIService from "src/servicehandlers/EmailAPIService";
import NotesAPIService from "src/servicehandlers/NotesAPIService";
import CheckridesAPIService from "src/servicehandlers/CheckridesAPIService";
import emailUtils from "src/util/emails.js";
import dayjs from "dayjs";

const emailAPIService = new EmailAPIService();
const checkridesAPIService = new CheckridesAPIService();
const notesAPIService = new NotesAPIService();

export default {
  components: { HiloModal, EmailTemplates, HiloTable, HiloButton, NotesModal },
  data() {
    return {
      selectedTab: "Scheduled",
      showPersonalDetails: false,
      showDpeEmailModal: false,
      showStudentEmailModal: false,
      selectedCheckride: {},
      showEmailTemplates: false,
      emailTemplates: [],
      // V2
      // isTaskModalOpen: false,
      allCheckrides: [],
      scheduledCheckrides: [],
      availableCheckrides: [],
      pendingCheckrides: [],
      completedCheckrides: [],
      search: "",
      showNotesModal: false,
      columns: [
        {
          key: "edit",
          label: "Edit",
          component: "HiloButton",
          componentProps: (row) => ({
            styleType: "editIcon",
            onClick: () => this.navigateToEditCheckride(row.id),
          }),
        },
        { key: "lastName", label: "Last Name" },
        { key: "firstName", label: "First Name" },
        {
          key: "email",
          label: "Email",
          condition: () => this.showPersonalDetails,
        },
        {
          key: "phone",
          label: "Phone",
          condition: () => this.showPersonalDetails,
        },
        // V2
        // {
        //   key: "tasks",
        //   label: "Tasks",
        //   component: "HiloButton",
        //   componentProps: () => ({
        //     label: "View",
        //     onClick: () => this.openTaskModal(),
        //   }),
        // },
        { key: "status", label: "Status" },
        { key: "type", label: "Type" },
        { key: "date", label: "Date" },
        { key: "startTime", label: "Start" },
        { key: "endTime", label: "End" },
        { key: "dpe", label: "DPE" },
        { key: "instructor", label: "Instructor" },
        { key: "tailNumber", label: "Tail Number" },
        {
          key: "dpeEmailSent",
          label: "Email DPE",
          component: "HiloButton",
          componentProps: (row) => ({
            styleType: row.dpeEmailSent ? "greenCheckButton" : "default",
            label: row.dpeEmailSent ? "Sent" : "Send",
            onClick: () => this.handleDpeEmailClick(row),
          }),
        },
        {
          key: "studentEmailSent",
          label: "Email Student",
          component: "HiloButton",
          componentProps: (row) => ({
            styleType: row.studentEmailSent ? "greenCheckButton" : "default",
            label: row.studentEmailSent ? "Sent" : "Send",
            onClick: () => this.handleStudentEmailClick(row),
          }),
        },
        { key: "resultStatus", label: "Result Status" },
        {
          key: "notes",
          label: "Notes",
          component: "HiloButton",
          componentProps: (row) => ({
            label: "View",
            onClick: () => this.openNotesModal(row),
          }),
        },
      ],
      tasks: [
        { id: 1, name: "Needs schedule", assignedTo: 1 },
        { id: 2, name: "Collect Checkride Fee", assignedTo: 2 },
        { id: 3, name: "Email DPE", assignedTo: 1 },
      ],
      assignedToOptions: [
        { id: 1, name: "Carly" },
        { id: 2, name: "Tyler" },
      ],
      taskOptions: [
        { id: 1, name: "Needs schedule" },
        { id: 2, name: "Collect Checkride Fee" },
        { id: 3, name: "Email DPE" },
      ],
    };
  },
  async mounted() {
    await this.getCheckrides();
    const templateNames = [
      {
        name: "DPE Checkride",
        title: "DPE Email Template",
        variables: this.getCheckrideEmailVariables(),
      },
      {
        name: "Student Checkride",
        title: "Student Email Template",
        variables: this.getCheckrideEmailVariables(),
      },
    ];
    this.emailTemplates = await emailUtils.getEmailTemplates(templateNames);
  },
  computed: {
    filteredCheckrides() {
      switch (this.selectedTab) {
        case "Scheduled":
          return this.scheduledCheckrides;
        case "Available":
          return this.availableCheckrides;
        case "Pending":
          return this.pendingCheckrides;
        case "Completed":
          return this.completedCheckrides;
        default:
          return [];
      }
    },
    dpeEmailFooterButtons() {
      return emailUtils.generateFooterButtons(
        () => this.closeModal("showDpeEmailModal"),
        this.sendDpeEmail,
      );
    },
    studentEmailFooterButtons() {
      return emailUtils.generateFooterButtons(
        () => this.closeModal("showStudentEmailModal"),
        this.sendStudentEmail,
      );
    },
  },
  methods: {
    async getCheckrides() {
      const checkrides = await checkridesAPIService.get();
      this.allCheckrides = checkrides.map((checkride) => {
        checkride.lastName = checkride.activeStudent?.user.lastName || "-";
        checkride.firstName = checkride.activeStudent?.user.firstName || "-";
        checkride.phone = checkride.activeStudent?.user.phone || "-";
        checkride.email = checkride.activeStudent?.user.email || "-";
        checkride.status = checkride.checkrideSchedulingStatus?.name;
        checkride.type = checkride.program?.name;

        checkride.date = checkride.startDateTime
          ? dayjs(checkride.startDateTime).format("MM/DD/YYYY")
          : "-";
        checkride.startTime = checkride.startDateTime
          ? dayjs(checkride.startDateTime).format("h:mm A")
          : "-";
        checkride.endTime = checkride.endDateTime
          ? dayjs(checkride.endDateTime).format("h:mm A")
          : "-";

        const dpe = checkride.dpe?.user;
        checkride.dpe = dpe ? `${dpe.firstName} ${dpe.lastName}` : "-";
        checkride.dpeEmail = dpe ? dpe.email : "-";

        const instructor = checkride.activeInstructor?.user;
        checkride.instructor = instructor
          ? `${instructor.firstName} ${instructor.lastName}`
          : "-";

        checkride.tailNumber = checkride.aircraft?.tailNumber || "-";
        checkride.resultStatus = checkride.checkrideResultStatus?.name || "-";

        return checkride;
      });
      this.filterCheckrideTypes(this.allCheckrides);
    },
    openNotesModal(row) {
      this.selectedCheckride = row;
      this.showNotesModal = true;
    },
    filterCheckrideTypes(checkrides) {
      this.scheduledCheckrides = checkrides
        .filter((checkride) => checkride.resultStatus === "-")
        .filter((checkride) => checkride.status === "Scheduled");

      this.availableCheckrides = checkrides
        .filter((checkride) => checkride.resultStatus === "-")
        .filter((checkride) => checkride.status === "Available");

      this.pendingCheckrides = checkrides
        .filter((checkride) => checkride.resultStatus === "-")
        .filter((checkride) => checkride.status === "Pending");

      this.completedCheckrides = checkrides.filter(
        (checkride) => checkride.resultStatus !== "-",
      );
    },
    navigateToAddCheckride() {
      this.$router.push({ name: "Add Edit Checkride" });
    },
    navigateToEditCheckride(id) {
      this.$router.push({ name: "Add Edit Checkride", params: { id } });
    },
    selectTab(tab) {
      this.selectedTab = tab;
    },
    toggleShowEmailTemplates() {
      this.showEmailTemplates = !this.showEmailTemplates;
    },
    openEmailModal(templateTitle, row, modalName) {
      const template = this.emailTemplates.find(
        (t) => t.title === templateTitle,
      );
      const populatedBody = emailUtils
        .replacePlaceholders(template.body, row)
        .replace(/\n/g, "<br>");
      this.selectedCheckride = {
        ...row,
        subject: template.subject,
        body: populatedBody,
      };
      this[modalName] = true;
    },
    handleDpeEmailClick(row) {
      this.openEmailModal("DPE Email Template", row, "showDpeEmailModal");
    },
    handleStudentEmailClick(row) {
      this.openEmailModal(
        "Student Email Template",
        row,
        "showStudentEmailModal",
      );
    },
    async sendDpeEmail() {
      await checkridesAPIService.sendDpeEmail(this.selectedCheckride.id, {
        id: this.selectedCheckride.id,
        email: this.selectedCheckride.dpeEmail,
        subject: this.selectedCheckride.subject,
        body: this.selectedCheckride.body,
      });
      await this.getCheckrides();
      this.closeModal("showDpeEmailModal");
    },
    async sendStudentEmail() {
      await checkridesAPIService.sendStudentEmail(this.selectedCheckride.id, {
        id: this.selectedCheckride.id,
        email: this.selectedCheckride.email,
        subject: this.selectedCheckride.subject,
        body: this.selectedCheckride.body,
      });
      this.closeModal("showStudentEmailModal");
      await this.getCheckrides();
    },
    closeModal(modalName) {
      this[modalName] = false;
      this.selectedCheckride = {};
    },
    async saveEmailTemplateChanges(updatedTemplates) {
      await emailUtils.saveEmailTemplates(updatedTemplates);
      this.emailTemplates = updatedTemplates;
    },
    getCheckrideEmailVariables() {
      return [
        "{{firstName}}",
        "{{lastName}}",
        "{{email}}",
        "{{phone}}",
        "{{type}}",
        "{{date}}",
        "{{startTime}}",
        "{{endTime}}",
        "{{dpe}}",
        "{{instructor}}",
        "{{tailNumber}}",
      ];
    },
    filterCheckrides() {
      const searchTerm = this.search.toLowerCase();
      const columnKeys = this.columns.map((column) => column.key);
      const filteredCheckrides = this.allCheckrides.filter((checkride) => {
        return columnKeys.some((key) => {
          const value = checkride[key];
          return value && value.toString().toLowerCase().includes(searchTerm);
        });
      });
      this.filterCheckrideTypes(filteredCheckrides);
    },
    // V2 -- maybe create a modal for tasks
    // openTaskModal() {
    //   this.isTaskModalOpen = true;
    // },
    // closeTaskModal() {
    //   this.isTaskModalOpen = false;
    // },
    // addTask() {
    //   this.tasks.push({
    //     id: this.tasks.length + 1,
    //     name: "",
    //     assignedTo: this.assignedToOptions[0],
    //   });
    // },
    // deleteTask(taskId) {
    //   this.tasks = this.tasks.filter((task) => task.id !== taskId);
    // },
    replacePlaceholders(template, student) {
      return template
        .replace(/{{firstName}}/g, student.firstName)
        .replace(/{{lastName}}/g, student.lastName)
        .replace(/{{email}}/g, student.email)
        .replace(/{{phone}}/g, student.phone)
        .replace(/{{type}}/g, student.type)
        .replace(/{{date}}/g, student.date)
        .replace(/{{startTime}}/g, student.startTime)
        .replace(/{{endTime}}/g, student.endTime)
        .replace(/{{dpe}}/g, student.dpe)
        .replace(/{{instructor}}/g, student.instructor)
        .replace(/{{tailNumber}}/g, student.tailNumber);
    },
  },
};
</script>

<style scoped>
.tab-container {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}

.tab {
  background-color: #888;
  color: white;
  padding: 5px 30px;
  font-size: 16px;
  cursor: pointer;
  margin-right: 0;
  border-radius: 8px 8px 0 0;
}

.tab.selected {
  background-color: #444;
  color: white;
}

.search-wrapper {
  margin-left: auto;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.toggle-container {
  display: flex;
  align-items: center;
}

.table-header {
  background-color: #f4f4f4;
  padding: 10px;
  display: flex;
  flex-direction: column;
}

.toggle-label {
  font-size: 14px;
  margin-right: 10px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 16px;
  margin-bottom: 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
  left: -9999px;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 16px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: black;
}

input:checked + .slider:before {
  transform: translateX(14px);
}

.button-margins {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 10px;
}

.tasks-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #f4f4f4;
}

.tasks-table th,
.tasks-table td {
  padding: 8px;
}

.assigned-to-select {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #f4f4f4;
  padding: 20px;
  border-radius: 8px;
  width: 60%;
  max-width: 600px;
  position: relative;
}

.close {
  color: #aaa;
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.button-row {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  gap: 10px;
}

.delete-button:hover i {
  color: #c43d33;
}

.delete-button {
  background-color: transparent;
  border: none;
}

.delete-button i {
  color: #d9534f;
  margin: 0;
}
</style>
